import axios from "axios";

const instance = axios.create({
  withCredentials: true
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    // Detecta expiração de sessão (401 Unauthorized)
    if (error && error.response && error.response.status === 401) {
      console.warn('🔒 Sessão expirada! Redirecionando para login...');

      // Limpa dados locais
      localStorage.removeItem('usuario_movimentacoes_servidores');

      // Redireciona para autenticação com redirect para página atual
      // Usa import dinâmico para evitar dependência circular
      import('../router').then((routerModule) => {
        const router = routerModule.default;
        const currentPath = router.currentRoute && router.currentRoute.fullPath;
        router.replace({
          name: "Autenticar",
          query: { redirect: currentPath }
        });
      });
    }

    // Trata 404 APENAS para rotas de navegação, NÃO para APIs
    // APIs devem retornar 404 normalmente para serem tratadas pelos componentes
    if(error && error.response && error.response.status === 404) {
      const url = error.config?.url || '';
      const isApiCall = url.includes('/api/');

      // Só redireciona para NaoEncontrado se NÃO for chamada de API
      if (!isApiCall) {
        import('../router').then((routerModule) => {
          const router = routerModule.default;
          const currentPath = router.currentRoute && router.currentRoute.path;
          router.replace({ name: "NaoEncontrado", query: { url: currentPath } });
        });
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
